import React from "react";
import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { Zap, FileText, Inbox, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-[#F8F8F9]">
      <header className="sticky top-0 z-40 bg-[#0A0A0C]/85 backdrop-blur-xl border-b border-white/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
          <Link to="/admin/blog" className="flex items-center gap-2" data-testid="admin-brand-link">
            <span className="flex items-center justify-center w-8 h-8 rounded-md bg-gradient-to-br from-[#FF8C00] to-[#FF5A00]">
              <Zap className="w-4 h-4 text-[#0A0A0C]" strokeWidth={3} />
            </span>
            <span className="font-display font-black text-lg text-white">
              perfo<span className="text-[#FF8C00]">range</span>
            </span>
            <span className="ml-2 text-[10px] font-mono-tech uppercase tracking-[0.25em] text-[#FF8C00] border border-[#FF8C00]/40 rounded-md px-2 py-0.5">
              Admin
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" data-testid="admin-nav">
            <NavLink
              to="/admin/blog"
              data-testid="admin-nav-blog"
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#FF8C00]/10 text-[#FF8C00]" : "text-[#A1A1AA] hover:text-white hover:bg-white/5"
                }`
              }
            >
              <FileText className="w-4 h-4" /> Blog
            </NavLink>
            <NavLink
              to="/admin/leads"
              data-testid="admin-nav-leads"
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#FF8C00]/10 text-[#FF8C00]" : "text-[#A1A1AA] hover:text-white hover:bg-white/5"
                }`
              }
            >
              <Inbox className="w-4 h-4" /> Leads
            </NavLink>
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="/"
              target="_blank"
              rel="noopener"
              className="hidden sm:inline-flex items-center gap-1.5 text-xs font-semibold text-[#A1A1AA] hover:text-white"
              data-testid="admin-view-site"
            >
              View site <ExternalLink className="w-3 h-3" />
            </a>
            <span className="hidden md:block text-xs font-mono-tech uppercase tracking-widest text-[#6a6a70]">
              {user?.email}
            </span>
            <button
              onClick={onLogout}
              data-testid="admin-logout"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-white/5 border border-white/10 text-[#D4D4D8] text-xs font-semibold hover:bg-white/10"
            >
              <LogOut className="w-3.5 h-3.5" /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <Outlet />
      </main>
    </div>
  );
}
